import { render, staticRenderFns } from "./CheckboxConfigurator.vue?vue&type=template&id=0b8be600"
import script from "./CheckboxConfigurator.vue?vue&type=script&lang=js"
export * from "./CheckboxConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports